export default __webpack_public_path__ + "static/media/today1.6f6870c7.jpg";